import React from "react";
import LoadingPlaceholderBlock from "../../../../../components/common/LoadingPlaceholderBlock";
import styles from "../Utilities/Styles.module.css"

export default function ConversationCsatLoader() {
    return (
        <div className={styles.h65}>
            <LoadingPlaceholderBlock width={'100%'} height={'65px'} backgroundColor={'rgb(239, 234, 229)'} />
        </div>
    )
}